module.exports = __webpack_public_path__ + "media/images/sebastiao_sobre-a8135704058694a05ebe1d42e6c40207.png";